import ProSurvey from "../../../../src/events/2022/09/dabang-pro-survey/main";
import * as React from 'react';
export default {
  ProSurvey,
  React
};